import { render, staticRenderFns } from "./ProfileList.vue?vue&type=template&id=2b1467c3&"
import script from "./ProfileList.vue?vue&type=script&lang=js&"
export * from "./ProfileList.vue?vue&type=script&lang=js&"
import style0 from "./ProfileList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports